import React, { useState } from 'react';
import { useNotifications } from '../../context/NotificationContext';
import { useAuth } from '../../context/AuthContext'; 
import NotificationDropdown from './NotificationDropdown';
import './styles/Notifications.css';

const NotificationBell = () => {
  const { unreadCount } = useNotifications();
  const { isAuthenticated } = useAuth(); // Check authentication
  const [isOpen, setIsOpen] = useState(false);

  // ONLY RENDER IF AUTHENTICATED
  if (!isAuthenticated) {
    return null; // Don't show bell if not logged in
  }

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  return (
    <div className="notification-bell">
      <button className="notification-button" onClick={toggleDropdown}>
        <i className="fas fa-bell"></i>
        {unreadCount > 0 && (
          <span className="notification-badge">{unreadCount}</span>
        )}
      </button>

      {isOpen && (
        <NotificationDropdown onClose={closeDropdown} />
      )}
    </div>
  );
};

export default NotificationBell;
